// extracted by mini-css-extract-plugin
module.exports = {"root":"IconClose_root__oKJ1D"};